import { render, staticRenderFns } from "./TutorsEditWrapper.vue?vue&type=template&id=f2be3536&"
import script from "./TutorsEditWrapper.vue?vue&type=script&lang=js&"
export * from "./TutorsEditWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports